import { Menu } from 'lucide-react'
import { Button } from '../ui/button'

interface MobileHeaderProps {
  onMenuClick: () => void
}

export function MobileHeader({ onMenuClick }: MobileHeaderProps) {
  return (
    <header className="sticky top-0 z-50 bg-white border-b shadow-sm lg:hidden">
      <div className="relative flex items-center justify-center px-4 py-3">
        <Button
          variant="ghost"
          size="icon"
          onClick={onMenuClick}
          className="absolute left-4 text-primary"
          aria-label="Navigatiemenu openen"
          aria-expanded="false"
        >
          <Menu className="h-6 w-6" aria-hidden="true" />
        </Button>

        <div className="flex items-center space-x-2">
          <img src="/crisisbuddy_logo.png" alt="BGCH Crisis Buddy logo" className="h-12 object-contain" />
        </div>
      </div>
    </header>
  )
}
